export default {
  setNotifications(state, notifications) {
    state.notifications = notifications || [];
  },
  setNotificationsQuantity(state, quantity) {
    state.notificationsQuantity = quantity || 0;
  },
};
